import { ThemeProvider } from 'styled-components'

import { theme } from '@reveni-io/reveni-ui'

const WhiteLabelThemeProvider = ({ buildTheme, children }) => (
  <ThemeProvider theme={buildTheme ? buildTheme(theme.whiteLabel) : theme.whiteLabel}>{children}</ThemeProvider>
)

export default WhiteLabelThemeProvider
